import {isFeatureEnabled} from 'feature-flags';
import {match} from 'ts-pattern';

import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';

/*
    Checks if an advertisement platform is enabled based on the feature flag.
    @param platform - The platform to check.
    @returns True if the platform is enabled, false otherwise.
*/
export const isAdvertisementPlatformEnabled = (platform: {code: string}) =>
  match(platform.code)
    .with(AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE_REST, () =>
      isFeatureEnabled(featureFlags.ADVERTISEMENT_MERCEDES_NA_SKLADE_REST)
    )
    .with(AdvertisingPlatformCodeEnum.FACEBOOK, () =>
      isFeatureEnabled(featureFlags.ADVERTISEMENT_FACEBOOK)
    )
    .with(AdvertisingPlatformCodeEnum.SAMOCHODY_PL, () =>
      isFeatureEnabled(featureFlags.ADVERTISEMENT_SAMOCHODY_PL)
    )
    .with(AdvertisingPlatformCodeEnum.VGP, () => isFeatureEnabled(featureFlags.ADVERTISEMENT_VGP))
    .with(AdvertisingPlatformCodeEnum.AUDI_PL, () =>
      isFeatureEnabled(featureFlags.ADVERTISEMENT_AUDI_PL)
    )
    .otherwise(() => true);
